import React from "react";
import styled from "styled-components";

export default styled.a`
    background: #5562c0 !important;
    text-align: center;
    padding: 14px 21px;
    color: white;
    margin: 0 auto 33px;
    border: 0;
    cursor: pointer;
    font-weight: 700;
    font-size: 20px;
    line-height: 17px;
    box-shadow: 5px 5px 25px #5562c04a;
    
    display: inline-block;
    text-decoration: none;
    i {
        margin-left: 19px;
        font-size: 17px;    
    }
`;